import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LogisticsService {

  
   //_url = 'http://localhost/reception';

//_url= 'http://multiinspectionreport.com/reception/api';
//_url= 'https://test.appointele.com/api';
//_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';

message = [];
  alltodaysschedules=[];
  userschedules=[];
  myschdules=[];
 branchs=[];
 salesrepbybranch=[];
 alltimeslot:any=[];
  constructor(private _http: HttpClient) { }


  insertNewScheduleByReception(questionaireForm) {
   
    return this._http.post<any>(`${this._url}/new_logistic_schedule_by_reception_insert.php`, questionaireForm)
  }


  
  getSalesRepByBranch(branch){
    return this._http.get(`${this._url}/salesrep_by_branch_get.php?branch=${branch}`).pipe(
       
       map((res) => {
        this.salesrepbybranch=[res];
       //  console.log(Object.assign(this.salesrepbybranch[0]));
         //console.log(len);
         return this.salesrepbybranch[0];
        //return len;
     }),

       catchError(this.handleError));
   }


  getMainSalesRepByBranch(branch){
    return this._http.get(`${this._url}/salesrep_by_branch_get_main.php?branch=${branch}`).pipe(
       
       map((res) => {
        this.salesrepbybranch=[res];
       //  console.log(Object.assign(this.salesrepbybranch[0]));
         //console.log(len);
         return this.salesrepbybranch[0];
        //return len;
     }),

       catchError(this.handleError));
   }


  getAllBranchs(){
    return this._http.get(`${this._url}/get_all_branchs.php`).pipe(
      map((res) => {
        this.branchs = res['data'];
        return this.branchs;
    }),
    
    catchError(this.handleError));
    }

  getAllTodaysLogisticSchedules(branch){
    return this._http.get(`${this._url}/active_logistics_schedules_for_today_get.php?branch=${branch}`).pipe(
      map((res) => {
        //this.alltodaysapointment = res;
       // console.log(this.alltodaysapointment);
        //return this.alltodaysapointment;
        return res;
    }),
  
    catchError(this.handleError));
   
    }

    getAllSchedulesForBranch(branch){
      return this._http.get(`${this._url}/active_all_logistics_schedules_for_branch_get.php?branch=${branch}`).pipe(
        map((results) => {
        this.alltodaysschedules = results['results'];
          console.log(this.alltodaysschedules);
          //return this.alltodaysapointment;
          return this.alltodaysschedules;
      }),
    
      catchError(this.handleError));
     
      }


      
  getScheduleDetails(pid,fullName,phoneNumber,branch,pickupTime){
    return this._http.get(`${this._url}/schedule_by_pid_get.php?pid=${pid}&fullName=${fullName}&phoneNumber=${phoneNumber}&branch=${branch}&pickupTime=${pickupTime}`)
    .pipe(    map((res) => {
    //  console.log(res);
      return res[0];
  }),
  
  catchError(this.handleError));
  }

    




  deleteSchedulebypid(schedule){
    //  console.log(appointment);
      //type is any and we are posting userData and return response as Observable
      return this._http.post<any>(`${this._url}/delete_schedule_by_pid.php`,schedule);
      }	
  
  completeAppointmentbypid(schedule){
    //console.log(appointment);
    //type is any and we are posting userData and return response as Observable
    return this._http.post<any>(`${this._url}/set_complete_schedule_by_pid.php`,schedule);
    }	
  


    getAllTodaysSchedules(branch){
      return this._http.get(`${this._url}/active_schedules_for_today_get.php?branch=${branch}`).pipe(
        map((res) => {
          //this.alltodaysapointment = res;
         // console.log(this.alltodaysapointment);
          //return this.alltodaysapointment;
          return res;
      }),
    
      catchError(this.handleError));
     
      }



      

  getUserSchedule(pid,fullName,phoneNumber,branch,pickUpTime){
    return this._http.get(`${this._url}/schedule_by_pid_get.php?pid=${pid}&fullName=${fullName}&phoneNumber=${phoneNumber}&branch=${branch}&pickupTime=${pickUpTime}`)
    .pipe(    map((res) => {
    //  console.log(res);
      return res[0];
  }),
  
  catchError(this.handleError));
  }



  
  
  updateSchedule(scheduleForm) {
    // console.log(appointmentForm)
     return this._http.post<any>(`${this._url}/schedule_update.php`, scheduleForm)
   }




  private handleError(error: HttpErrorResponse) {
    // console.log(error);
   
    
     // return an observable with a user friendly message
     return throwError('Error! something went wrong.');
   }
  
}
